import { useQuery } from '@tanstack/react-query';

import { useUser } from '@auth_module/hooks/useUser';
import { fetchApiKeys } from '@account_module/services/selfServeApi';
import { SELF_SERVE_API } from '@account_module/constants/selfServeApiKeys';

export const useSelfServeApiKeys = () => {
  const { organization } = useUser();
  const { data, isLoading, error } = useQuery({
    queryKey: [SELF_SERVE_API.KEYS, organization.id],
    queryFn: () => fetchApiKeys({ organization_id: organization.id }),
  });

  return { data: data?.data, isLoading, error };
};
